import { create } from "zustand";
import { persist } from 'zustand/middleware';

type USER = {
    id: number,
    USER: number,
    name: string,
    last_name: string,
    phone_number: string,
};

type STORE = {
    user: USER | null;
    setUser: (user: USER | null) => void;
};

export default USER;

export const useUserStore = create<STORE>()(
    persist(
        (set) => ({
            user: null,
            setUser: (user) => set({ user }),
        }),
        {
            name: 'user-storage',
        }
    )
);
